import { motion } from "framer-motion";
import { ReactComponent as LogoNegative } from "../../assets/img/logo-icon-negative.svg";
import { ReactComponent as Logo } from "../../assets/img/logo-icon.svg";
import { cn } from "lib/cn";

interface SpinnerProps {
    className?: string;
    size?: "sm" | "md" | "lg" | "xl";
    negativeLogo?: boolean;
}

const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-10 w-10",
    lg: "h-16 w-16",
    xl: "h-24 w-24",
};

export const Spinner = ({ className, size = "xl", negativeLogo = false }: SpinnerProps) => {
    const LogoComponent = negativeLogo ? LogoNegative : Logo;
    return (
        <div className={cn("flex items-center justify-center", sizeClasses[size], className)}>
            <motion.div
                animate={{
                    rotate: 360,
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "linear",
                }}
                style={{ width: "100%", height: "100%" }}
            >
                <motion.div
                    animate={{
                        opacity: [0.6, 1, 0.6],
                        scale: [0.95, 1.2, 0.95],
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: [0.65, 0, 0.35, 1],
                    }}
                    style={{ width: "100%", height: "100%" }}
                >
                    <LogoComponent style={{ width: "100%", height: "100%" }} />
                </motion.div>
            </motion.div>
        </div>
    );
};

// export const Spinner = ({ className }: { className?: string }) => {
//     return (
//         <div className={cn("flex h-6 w-6 items-center justify-center", className)}>
//             <motion.svg viewBox="0 0 300 300">
//                 <motion.path
//                     d="M 150 24.32 L 258.84 87.16 v 125.68 L 150 275.68 l -108.84 -62.84 V 87.16 L 150 24.32z"
//                     strokeWidth="40px"
//                     stroke="currentColor"
//                     fill="none"
//                     strokeLinejoin="round"
//                     strokeLinecap="round"
//                     animate={{ pathLength: [0, 1, 0], pathOffset: [0, 0, 1] }}
//                     transition={{ duration: 1.2, repeat: Infinity, ease: [0.65, 0, 0.35, 1] }}
//                     repeatCount={Infinity}
//                 />
//             </motion.svg>
//         </div>
//     );
// };
